export const getCashRequestDetail = (state) => state.cashRequestDetail;